import React from 'react';
import { LucideIcon } from 'lucide-react';

interface PublicPageHeaderProps {
    title: string;
    highlightedText?: string;
    description: string;
    icon: LucideIcon;
}

const PublicPageHeader: React.FC<PublicPageHeaderProps> = ({ title, highlightedText, description, icon: Icon }) => {
    const renderTitle = () => {
        if (!highlightedText) {
            return <span className="bg-clip-text text-transparent bg-gradient-to-r from-purple-400 via-pink-400 to-orange-400 font-serif">{title}</span>;
        }

        const parts = title.split(highlightedText);
        if (parts.length === 1) {
            return <span className="bg-clip-text text-transparent bg-gradient-to-r from-purple-400 via-pink-400 to-orange-400 font-serif">{title}</span>;
        }

        return (
            <>
                {parts[0]}
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-purple-400 via-pink-400 to-orange-400 font-serif">
                    {highlightedText}
                </span>
                {parts[1]}
            </>
        );
    };

    return (
        <div className="mb-10 md:mb-16 text-center px-4 relative">
            {/* Decorative background glow behind heading */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-32 bg-purple-600/10 blur-[80px] rounded-full pointer-events-none" />

            <div className="inline-flex items-center justify-center p-3 rounded-2xl bg-purple-500/10 mb-6 md:mb-8 border border-purple-500/20 shadow-lg shadow-purple-500/5 relative z-10 transition-transform hover:scale-105 duration-300">
                <Icon className="text-purple-400 w-8 h-8 md:w-10 md:h-10" />
            </div>

            <h1 className="text-5xl md:text-7xl font-black text-white mb-6 md:mb-8 font-serif tracking-tight leading-[1.1] relative z-10">
                {renderTitle()}
            </h1>
            <p className="text-purple-200/80 font-sans text-lg md:text-xl max-w-2xl mx-auto leading-relaxed relative z-10">
                {description}
            </p>
        </div>
    );
};

export default PublicPageHeader;
